<template>
  <button
    type="button"
    class="text-2xl bg-EXPONDO-grey-5
          border-EXPONDO-grey-20 disabled:text-EXPONDO-grey-60"
    :class="{
      'px-0 w-8': isSmall,
      'px-0 w-12': isLarge,
      'px-3.5 font-semibold': !isSmall && !isLarge,
      'rounded-l-md border-r': isLeft,
      'rounded-r-md border-l': !isLeft
    }"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script lang="ts">

export default defineComponent({
  name: 'QuantitySelectorButton',
  props: {
    isLeft: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    isLarge: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
});

</script>
